import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { format } from "date-fns";
import { api } from "@/lib/api";

// Custom marker
const markerIcon = L.divIcon({
  className: "",
  html: '<div style="width:14px;height:14px;background:#2563EB;border:2px solid #09090B;border-radius:50%;box-shadow:0 0 0 4px rgba(37,99,235,.18)"></div>',
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
    map.fitBounds(bounds, { padding: [40, 40] });
  }, [points, map]);
  return null;
}

export default function MapPage() {
  const [confs, setConfs] = useState([]);
  useEffect(() => { api.get("/conferences/all").then((r) => setConfs(r.data)); }, []);

  const points = confs.filter((c) => c.lat && c.lng);

  return (
    <div data-testid="map-page" className="px-6 md:px-10 lg:px-16 py-10 md:py-12">
      <div className="overline mb-3">View · Atlas</div>
      <h1 className="font-display font-black text-5xl md:text-6xl tracking-[-0.04em] leading-none mb-3">World Atlas</h1>
      <p className="text-zinc-600 max-w-2xl">Every conference plotted by location.</p>

      <div className="mt-10 border border-zinc-200 map-mono" style={{ height: "72vh" }}>
        <MapContainer center={[30, 10]} zoom={2} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; OpenStreetMap'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {points.map((c) => (
            <Marker key={c.id} position={[c.lat, c.lng]} icon={markerIcon}>
              <Popup>
                <div className="font-display font-semibold text-base leading-tight mb-1">{c.title}</div>
                <div className="text-xs text-gray-600 mb-2">{format(new Date(c.start_date), "MMM d, yyyy")} · {c.city}, {c.country}</div>
                <Link to={`/conferences/${c.id}`} className="text-xs underline font-medium">View details →</Link>
              </Popup>
            </Marker>
          ))}
          <FitBounds points={points} />
        </MapContainer>
      </div>

      <div className="mt-6 text-xs font-mono text-gray-500" data-testid="map-count">{points.length} location{points.length !== 1 ? "s" : ""} plotted</div>
    </div>
  );
}
